import { render, staticRenderFns } from "./errortips.vue?vue&type=template&id=bb4f2daa&scoped=true&"
import script from "./errortips.vue?vue&type=script&lang=js&"
export * from "./errortips.vue?vue&type=script&lang=js&"
import style0 from "./errortips.vue?vue&type=style&index=0&id=bb4f2daa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4f2daa",
  null
  
)

export default component.exports